module.exports = __webpack_public_path__ + "static/media/Point Layout.9ea97a53.png";